import React from 'react'
import {  withRouter } from 'react-router-dom'
import './style.scss'

const Index = props => {

    const proceedBack = () => {
        props.history.push('/dashboard/oversikt')
    }

    return(
        <div className="dashboard-validate-success-container">
            <div className="inner-dashboard-validate-success-container">
                <h1 className="success-icon"><i class="far fa-check-square"></i></h1>
                <h3 className="success-title">Abonnement er aktivt.</h3>
                <p className="success-description">Betalingen var vellykket og abonnementet ditt er nå aktivt.</p>
                <button onClick={() => proceedBack()} className="proceed-button">Gå til oversikt</button>
            </div>
        </div>
    )
}

export default withRouter(Index)